module.exports = __webpack_public_path__ + "img/dimequest-progress-circle-wire.d16b67a9.png";